<template>
  <v-card class="elevation-12">
    <TemplateDataTable
    />
  </v-card>
</template>


<script>
import {LAYOUT_TITLE_CHANGED} from "@/store/modules/layout/actions";
import TemplateDataTable from "@/components/template/TemplateDataTable.vue";

export default {
  name: "TemplatePage",
  components: {
    TemplateDataTable,
  },
  created() {
    this.$store.dispatch(LAYOUT_TITLE_CHANGED, this.$t('templatePage.pageTitle'))
  }
}
</script>